/* Program Name: PageNotFound.js
 **  Description: a 404 error page for URLs React Router doesnt know how to
 **               handle.
 **
 ** Project    Date        Who  Comments
 ** ---------  ----------  ---  ---------------------------------------------------
 ** IS0200241  2021-03-17  STT  Initial program
 *********************************************************************************/

/** React imports */
import React from 'react'

/**PageNotFound *****************************************************************/

const PageNotFound = () => {
  /******************************************************************************/
  /**Rendering */

  return (
    <div>
      <h1>Page Not Found</h1>
    </div>
  )
}

export default PageNotFound
